import api from './api';

export function getCatalogoTcds(codAsesor) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/cdt/${codAsesor}/catalogo`);
}

export function getCatalogoTcdsMambu(codAsesor) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/cdt/${codAsesor}/catalogoMambu`);
}
